export const MAIL_TO="madet.adrien@gmail.com, vs.violainesimon@gmail.com";


// WEBPACK FOOTER //
// ./src/config/constants.js